/**
 * The predefined issues: questions the project's assistant can answer from the
 * reporter's own account and close, offered in the widget as one-tap choices.
 *
 * The API decides the list (GET /ingest/agent-issues) — it is empty unless the
 * project has the Sphoro Agent answering questions and a data source that can
 * answer them. Every failure is an empty list: the tiles are a shortcut, and a
 * widget that could not load them is still a widget that files reports.
 *
 * The agent ends its answer with SOLVED_QUESTION's wording; the widget draws
 * Yes / No under it (widget.js messageHtml). Keep this pattern in step with
 * agent-issues.ts SOLVED_QUESTION in the API and workers.
 */
export const SOLVED_PROMPT = /Did this answer your question\?/i;

export async function fetchAgentIssues({ apiBase, apiKey, projectId }) {
  try {
    const res = await fetch(
      `${apiBase}/ingest/agent-issues?projectId=${encodeURIComponent(projectId)}`,
      { headers: { 'X-BugCatch-Key': apiKey } },
    );
    if (!res.ok) return [];
    const body = await res.json();
    return (Array.isArray(body?.issues) ? body.issues : [])
      .filter((i) => i && typeof i.key === 'string' && typeof i.title === 'string')
      .map((i) => ({ key: i.key, title: i.title, hint: typeof i.hint === 'string' ? i.hint : '' }));
  } catch {
    return [];
  }
}
